export default "__VITE_ASSET__DIyvuoU5__"